import { BrandVariants, createDarkTheme, createLightTheme, Theme } from '@fluentui/react-components';

const cmThemeBranding: BrandVariants = {
  10: '#020305',
  20: '#02121C',
  30: '#012032',
  40: '#012F49',
  50: '#013E5F',
  60: '#014D76',
  70: '#005B8C',
  80: '#006AA3',
  90: '#1F7CAF',
  100: '#3F8FBA',
  110: '#5EA1C6',
  120: '#7EB4D1',
  130: '#9DC6DD',
  140: '#BCD8E8',
  150: '#DCEBF4',
  160: '#FBFDFF',
};

export const cmLightTheme: Theme = {
  ...createLightTheme(cmThemeBranding),
};

export const cmDarkTheme: Theme = {
  ...createDarkTheme(cmThemeBranding),
};

cmDarkTheme.colorBrandForeground1 = cmThemeBranding[110];
cmDarkTheme.colorBrandForeground2 = cmThemeBranding[120];
